import React, { useEffect, useState } from "react";
import {
    Box,
    Table,
    VStack,
    Text,
    IconButton,
    Input,
    HStack, Flex
} from "@chakra-ui/react";
import { FiTrash2 } from "react-icons/fi";
import ToggleButton from "../../Components/ui/ToggleButton";
import { Tooltip } from "../../Components/ui/tooltip";
import { useDispatch } from "react-redux";
import { deleteUser, getUsersList, updateUserStatus } from "../../Redux/Action";
import { getLocalStorageItem } from "../../Utils/Helper";
import { FaRegEye } from "react-icons/fa";
import { UserListSkeleton } from "../../Components/custom/Skeletons/UserListSkeleton";
import { PasswordChangeModal } from "../../Components/custom/PassWordChangeModal";
import { ViewPasswordModal } from "../../Components/custom/ViewPasswordModal";
import { FiEdit } from "react-icons/fi";
import { CustomPagination } from "../../Components/custom/CustomPagination";
export const WhiteLabelDataTable = () => {
    const dispatch = useDispatch();
    const [users, setUsers] = useState([]);
    const [isDataLoading, setisDataLoading] = useState(true);
    const [totalPagesCount, setTotalPagesCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowCount, setRowCount] = useState(10);
    const [statusToggle, setStatusToggle] = useState({});
    const [refetch, setRefetch] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const whitelabelLocalStorage = getLocalStorageItem("whitelabelData");
    const [viewPasswordUser, setViewPasswordUser] = useState(null);
    const [editPassword, setEditPassword] = useState(false);
    const [editPasswordData, setEditPasswordData] = useState(false);
    const handleToggleStatus = (user) => {

        dispatch(updateUserStatus({ status: user?.status ? 0 : 1, id: user?._id }));
    };
    const handleEditPassword = (data) => {
        setEditPassword(true);
        setEditPasswordData(data);
    };
    const handleDelete = (id) => {
        dispatch(
            deleteUser({
                id,
                callback: (data) => {
                    if (data.meta.code === 200) {
                        handlerefetchData();
                    }
                },
            })
        );
    };

    const handlerefetchData = () => setRefetch(!refetch);
    useEffect(() => {
        setisDataLoading(true);
        let payload

        if (whitelabelLocalStorage != null) {

            let whiteLabelID = whitelabelLocalStorage._id
            payload = {
                currentPage,
                rowCount,
                whiteLabelID,
                roleFilter: "whitelabel",
            };
        }
        else {
            payload = {
                currentPage,
                rowCount,
                roleFilter: "whitelabel",
            }
        }
        dispatch(
            getUsersList({
                payload,
                callback: (data) => {

                    if (data?.meta?.code === 200) {

                        setUsers(data?.data?.users);
                        setisDataLoading(false);
                        setTotalPagesCount(data?.meta?.totalPages);
                    }
                },
            })
        );
    }, [currentPage, refetch]);

    return (

        isDataLoading ? <UserListSkeleton /> : <VStack spacing={4} align="stretch" width="100%">
            <Box
                overflow="auto"
                maxHeight="calc(100vh - 250px)"
                width="100%"
                borderRadius="md"
                bg="white"
                boxShadow="sm"
            >
               
                <Table.Root size="sm" variant="unstyled" width="100%">
                    <Table.Header>
                        <Table.Row bg="gray.100" position="sticky" top={0} zIndex={10}>
                            <Table.ColumnHeader textAlign="left">User Name</Table.ColumnHeader>
                            <Table.ColumnHeader textAlign="left">Balance</Table.ColumnHeader>
                            <Table.ColumnHeader textAlign="left">Created By</Table.ColumnHeader>
                            <Table.ColumnHeader textAlign="left">Account Number</Table.ColumnHeader>
                            <Table.ColumnHeader textAlign="left">Mobile</Table.ColumnHeader>
                            <Table.ColumnHeader textAlign="left">Promo Code</Table.ColumnHeader>

                            <Table.ColumnHeader textAlign="left">Password</Table.ColumnHeader>
                            <Table.ColumnHeader textAlign="left">Status</Table.ColumnHeader>
                            <Table.ColumnHeader textAlign="center">Delete</Table.ColumnHeader>
                            <Table.ColumnHeader textAlign="center">Action</Table.ColumnHeader>

                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {users?.length > 0 ? (
                            users.map((user, index) => {
                                const userId = user.uid || user.email || index;

                                return (
                                    <Table.Row
                                        key={userId}
                                        borderBottom="1px solid"
                                        borderColor="gray.200"
                                        _hover={{ bg: "gray.50" }}
                                    >
                                        <Table.Cell textAlign="left">{`${user.user_name || ""}`}</Table.Cell>
                                        <Table.Cell textAlign="left">{user.balance?.toFixed(2) || "0.00"}</Table.Cell>
                                        <Table.Cell textAlign="left">{user.createdBy || "-"}</Table.Cell>
                                        <Table.Cell textAlign="left">{user.accountno}</Table.Cell>
                                        <Table.Cell textAlign="left">
                                            {`${user.countryCode || ""}${user.mobile || ""}`}
                                        </Table.Cell>
                                        <Table.Cell textAlign="left">{user.promoCode || "-"}</Table.Cell>

                                        <Table.Cell textAlign="left">
                                            <HStack>
                                                <Tooltip content="View password">
                                                    <IconButton
                                                        variant="surface"
                                                        size="xs"
                                                        colorPalette="purple"
                                                        onClick={() => setViewPasswordUser(user)}
                                                        aria-label="View Password"
                                                    >
                                                        <FaRegEye />
                                                    </IconButton>
                                                </Tooltip>
                                                <IconButton
                                                    variant="surface"
                                                    size="xs"
                                                    colorPalette="cyan"
                                                    onClick={() => handleEditPassword(user)}
                                                >
                                                    <FiEdit />
                                                </IconButton>
                                            </HStack>
                                        </Table.Cell>
                                        <Table.Cell textAlign="left">
                                            <ToggleButton
                                                toggle={user?.status ? true : false}

                                                onToggle={() => handleToggleStatus(user)}
                                                identifier={userId}
                                            />
                                        </Table.Cell>
                                        <Table.Cell textAlign="center">
                                            <IconButton
                                                variant="surface"
                                                size="xs"
                                                colorPalette="red"
                                                onClick={() => handleDelete(user?._id)}
                                            >
                                                {<FiTrash2 />}
                                            </IconButton>
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            })
                        ) : (
                            <Table.Row>
                                <Table.Cell colSpan={11} textAlign="center" py={6}>
                                    <Text fontSize="sm" color="gray.500">
                                        No data available
                                    </Text>
                                </Table.Cell>
                            </Table.Row>
                        )}
                    </Table.Body>
                </Table.Root>
            </Box>
            {editPassword && (
                <PasswordChangeModal
                    data={editPasswordData}
                    isOpen={editPassword}
                    onClose={() => setEditPassword(false)}
                    refetchData={handlerefetchData}
                />
            )}
            {viewPasswordUser && (
                <ViewPasswordModal
                    user={viewPasswordUser}
                    isOpen={!!viewPasswordUser}
                    onClose={() => setViewPasswordUser(null)}
                />
            )}
            <Flex pt={4} justifyContent="center">
                <CustomPagination
                    totalCount={totalPagesCount}
                    current={currentPage}
                    setCurrent={setCurrentPage}
                    isLoading={isDataLoading}
                />
            </Flex>
        </VStack>


    );
};
